module.exports = __webpack_public_path__ + "static/media/oAuth2-logo.4d4d6950.svg";